/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./picture-manage.vue?vue&type=template&id=a4e3318e&scoped=true&"
import script from "./picture-manage.vue?vue&type=script&lang=ts&"
export * from "./picture-manage.vue?vue&type=script&lang=ts&"
import style0 from "./picture-manage.vue?vue&type=style&index=0&id=a4e3318e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e3318e",
  null
  
)

export default component.exports